<template>
  <div>
    <MixedKeyboard ref="mixedKeyboard"
        @onChanged="doChanged"
        @onBackClick="doBackClick"
        @onCommitClick="doCommitClick"
        @onClearClick="doClearClick"
    ></MixedKeyboard>
  </div>
</template>

<script>
import MixedKeyboard from "@/components/carkeyboard/MixedKeyboard.vue";

export default {
  props: ["onConfirm", "onCancel", "onClear"],

  components: {
    MixedKeyboard
  },

  methods: {
    clear() {
      this.$refs.mixedKeyboard.clear()
    },
    doChanged(number) {
      console.log("当前车牌输入 => ", number)
    },
    doBackClick() {
      console.log("用户点击返回的回调")
      this.onCancel()
    },

    doCommitClick(number, isCompleted) {
      console.log("用户点击[确认]的回调:number => ", number)
      console.log("用户点击[确认]的回调:isCompleted => ", isCompleted)
      this.onConfirm(number)
    },
    doClearClick() {
      console.log("用户点击[清除]的回调")
      this.onClear()
    },
  },


  data() {
    return {
      callbacks: {
        // 输入数据的回调
        onChanged: function (number) {
          console.log("当前车牌输入 => ", number)

        },

        // 用户点击返回按钮的回调
        onBackClick: function () {
          console.log("用户点击返回的回调")
          this.onCancel()
        },

        // 用户点击确认按钮的回调
        // number: 返回车牌；isCompleted: 是否完成输入
        onCommitClick: function (number, isCompleted) {
          console.log("用户点击[确认]的回调:number => ", number)
          console.log("用户点击[确认]的回调:isCompleted => ", isCompleted)
          this.onConfirm(number)

        },

        onClearClick: function () {
          console.log("用户点击[清除]的回调")
          this.onClear()
        }
      }
    }
  }
}
</script>

<style>

</style>
